export default class User {
    constructor(data = {}) {
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data.id || undefined;
        this.avatar = data.avatar || undefined;
        this.avatarUrl = data.avatarUrl || undefined;
        this.deactivated = data.deactivated !== undefined ? data.deactivated : false;
        this.email = data.email || undefined;
        this.firstname = data.firstname || undefined;
        this.lastname = data.lastname || undefined;
        this.setPermission(data);
        this.phoneNumber = data.phoneNumber || undefined;
        this.setProperties(data);
        this.roleId = data.roleId || undefined;
        this.roleName = data.roleName || undefined;
        this.username = data.username || undefined;
        this.tokenSession = data.tokenSession || undefined;
        this.deviceId = data.deviceId || undefined;
        this.vgid = data.crmId || undefined;
        this.mfaEnabled = data.mfaEnabled === true;
        this.forceMfa = data.forceMfa === true;
    }

    setPermission(data = {}) {
        this.permissions = data.permissions || [];
    }

    setProperties(data = {}) {
        this.propertyIds = data.propertyIds || [];
    }

    export() {
        return {
            id: this.id,
            avatar: this.avatar,
            avatarUrl: this.avatarUrl,
            deactivated: this.deactivated,
            propertyIds: this.propertyIds,
            permissions: this.permissions,
            roleId: this.roleId,
            roleName: this.roleName,
            email: this.email,
            firstname: this.firstname,
            lastname: this.lastname,
            username: this.username,
            phoneNumber: this.phoneNumber,
            avatar: this.avatar,
        }
    }
}
